<template>
  <el-tooltip
    :disabled="isChatReady"
    content="Please wait while the chat loads">
    <a
      :class="{
        'chat-icon-disabled': !isChatReady,
        'active': NoResultsTour.currentStep === 1
      }"
      class="chat-icon no-results-tour-1"
      @click="toggleChatWidget"/>
  </el-tooltip>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'ChatButton',
  data() {
    return {
      isChatReady: false
    }
  },
  computed: {
    ...mapGetters('accounts', ['email', 'name', 'phone']),
    ...mapState('tours', ['NoResultsTour'])
  },
  mounted() {
    // No chat client is loaded when CHAT_MODE is unset/unrecognized.
    if (!this.$chat || !this.$chat.elementId) {
      return
    }

    const elementId = this.$chat.elementId
    // Check if the chat widget has loaded after render
    if (document.getElementById(elementId)) {
      this.isChatReady = true
      this.setUserInChat()
    } else {
      // if chat widget is not yet ready, observe until ready
      const mutationObserver = new MutationObserver(() => {
        if (document.getElementById(elementId)) {
          mutationObserver.disconnect()
          this.isChatReady = true
          this.setUserInChat()
        }
      })

      mutationObserver.observe(document.body, {
        childList: true,
        subtree: true
      })
    }
  },
  methods: {
    toggleChatWidget() {
      this.noResultsTourEnd()
      this.$chat?.toggle()
    },
    noResultsTourEnd() {
      const NoResultsTour = this.$tours.NoResultsTour

      if (
        NoResultsTour &&
        NoResultsTour.isRunning &&
        NoResultsTour.currentStep === 1
      ) {
        NoResultsTour.stop()
      }
    },
    setUserInChat() {
      this.$chat.setUser({
        name: this.name,
        email: this.email,
        phone: this.phone
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.chat-icon-disabled {
  display: none;
}
</style>
